import _ from 'lodash';
import { i18n } from '../../language';

const bsMlookupListFunc = {
  getTypeAllLookup: (allData, lookupType) => {
    return _.find(allData, (item) => {
      return item.lookupType === lookupType;
    })?.lookupInfo;
  },
  getTypeLookup: function (allData, lookupType, lookUpValue) {
    const typeAllEnum = this.getTypeAllLookup(allData, lookupType);
    return _.find(typeAllEnum, (item) => {
      return item.lookUpValue === lookUpValue;
    });
  },
  getTypeLookupName: function (allData, lookupType, lookUpValue) {
    const typeAllEnum = this.getTypeAllLookup(allData, lookupType);
    return (
      _.find(typeAllEnum, (item) => {
        return item.lookUpValue === lookUpValue;
      })?.lookUpName ?? ''
    );
  },
  getTypeLookupFormat: function (allData, lookupType, lookUpValue) {
    const typeAllEnum = this.getTypeAllLookup(allData, lookupType, lookUpValue);
    return _.map(typeAllEnum, (item) => {
      return { text: item.lookUpName, value: item.lookUpValue };
    });
  },
  getTypeLookupAddBlankFormat: function (allData, lookupType) {
    const typeAllEnum = this.getTypeAllLookup(allData, lookupType);
    return [
      { text: 'N/A', value: '' },
      ...(_.map(typeAllEnum, (item) => {
        return { text: item.lookUpName, value: item.lookUpValue };
      }) ?? []),
    ];
  },
  isTypeLookupValueExist: function (allData, lookupType, lookUpValue) {
    const typeAllEnum = this.getTypeAllLookup(allData, lookupType);
    return Boolean(
      _.find(typeAllEnum, (item) => {
        return item.lookUpValue === lookUpValue;
      })
    );
  },

  getBSBookStatusAddTranslate: function (allData) {
    const bs_book_status = this.getTypeLookupFormat(allData, 'bs_book_status');
    return _.map(bs_book_status, (item) => {
      if (item.value === 'O') {
        return { text: 'Pending Adm.', value: item.value };
      } else if (item.value === 'C') {
        return { text: i18n.t('BEDSTATUS_COMPLETED_SINCE_24HOURS_AGO'), value: item.value };
      } else if (item.value === 'D') {
        return { text: i18n.t('BEDSTATUS_DELETED'), value: item.value };
      } else if (item.value === 'PFYA') {
        return { text: i18n.t('BEDSTATUS_PFYA'), value: item.value };
      } else if (item.value === 'P') {
        return { text: i18n.t('BEDSTATUS_PENDING'), value: item.value };
      } else if (item.value === 'A') {
        return { text: i18n.t('BEDSTATUS_ACCEPTED'), value: item.value };
      } else if (item.value === 'DL') {
        return { text: i18n.t('BEDSTATUS_DECLINED'), value: item.value };
      } else if (item.value === 'WR') {
        return { text: i18n.t('BEDSTATUS_WARD_READY'), value: item.value };
      } else if (item.value === 'RWR') {
        return { text: i18n.t('BEDSTATUS_RECV_WARD_READY'), value: item.value };
      }
      return item;
    });
  },
};

export { bsMlookupListFunc };
